import { LookupType } from '@constants/lookupTypes';

export type Severity = 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast';

export const SessionStorageKeys = {
  navigationHistoryStack: 'navigationHistoryStack',
};

export const Constraints = {
  ENTITY_OTHER_ID: 500,
  DATE_OF_BIRTH_MIN_AGE: 18,
  DATE_OF_BIRTH_MAX_AGE: 70,
};

export const QueryKeys = {
  ADVISOR_LOAN_REQUESTS: 'advisorLoanRequests',
  CUSTOMER_LOAN_REQUESTS: 'customerLoanRequests',
};

export const CommonEndpoints = {
  PUBLIC_LOOKUP: (lookupType: LookupType) => `api/v1/lookup/public/${lookupType}`,
  PRIVATE_LOOKUP: (lookupType: LookupType) => `api/v1/lookup/private/${lookupType}`,
};
